angular.module('impactx.search').component('ixProductGroupList', {
        bindings: {
            productGroups: '<',
            trns: '<'
        },
        require: {
            containerCtrl: '^^ixListTabContainer'
        },
        controller: 'ProductGroupSearchListCtrl',
        controllerAs: 'productGroupSearchListCtrl',
        templateUrl: 'modules/search/templates/product-group-list.html'
    }
);
